/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.$ = window.jQuery = require('jquery');

    require('bootstrap-sass');
    require('bootstrap-table');
    require('bootstrap-select');
    require('jquery-ui/ui/widgets/sortable');
    require('jquery-ui/ui/widgets/datepicker');
    //require('@izzius94/simpleupload');
    require('./components/basicUpload');
    require('./variabili');
    require('./funzioni');
    require('./eventi');
    require('jquery-ui/ui/i18n/datepicker-it');
    $.datepicker.setDefaults($.datepicker.regional[ "it" ]);
    $('.datepicker').datepicker({ 
            dateFormat: 'dd/mm/yy',
            minDate: new Date()
     });
    $('.selectpicker').selectpicker();
    require('../../../node_modules/slick-carousel/slick/slick.min.js');
} catch (e) {}



// WEBPACK FOOTER //
// ./resources/assets/js/bootstrap.js